import React from 'react';

import { Field } from 'react-final-form';

import { Radio, RadioGroup } from '@change/ds-forms/RadioGroup';

import { translationKey } from '@change-corgi/core/i18n';

import { useFormI18n } from '#src/app/shared/form/hooks';
import { requiredValidator } from '#src/app/shared/form/validators';

import type { Category, FormValues } from '../../shared/types';

import { useCategoryField } from './hooks/useCategoryField';

const validator = requiredValidator<Category>({
	i18n: { key: translationKey('corgi.policy_abuse.generic.errors.category_required') },
});

export const CategoryField: React.FC<EmptyProps> = () => {
	const { getErrorMessage } = useFormI18n();

	const {
		data: { categories },
		actions: { getLabel },
	} = useCategoryField();

	return (
		<div className="mb-6 p-1">
			<Field<FormValues['category']>
				name="category"
				type="radio"
				subscription={{ error: true, touched: true }}
				validate={validator}
			>
				{({ input: groupInput, meta }) => (
					<RadioGroup
						label=""
						labelIsVisible={false}
						aria-labelledby="abuse-modal-form-description"
						name="options"
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						errorMessage={meta.touched && getErrorMessage(meta.error)}
						isInvalid={meta.touched && !!meta.error}
						onChange={groupInput.onChange}
					>
						{categories.map((category) => (
							<Field<FormValues['category']> key={category} type="radio" value={category} name="category">
								{({ input }) => (
									<Radio
										value={input.value || ''}
										data-testid={`reportAbuse-category-${category}-radio`}
										data-qa={`reportAbuse-category-${category}-radio`}
									>
										{getLabel(category)}
									</Radio>
								)}
							</Field>
						))}
					</RadioGroup>
				)}
			</Field>
		</div>
	);
};
